export const SET_TOKEN = 'SET_TOKEN';
/** 创建userInfo变量（用于redux）*/
export const SET_USERINFO = "set_userInfo"